import Vue from "vue";
import Vuex from "vuex";
import $http from "./request.js";

Vue.use(Vuex);

const state = {
  commerceInfo:{},
  areaDefault: {},
  area: [],
  defaultInfo: null,
  baseInfo: {
    avatar: "",
    real_name: "",
    gender: "",
    birthday: "",
    birth_city_id:"",
    birth_county_id: "",
    birth_province_id: "",
    famous_family: "",
    education: "",
    polutical_status: "", //政治面貌
    weixin_id: "",
    mobile: "",
    id_card: "", //身份证号码
    assistant_list: [], //助理信息  电话和姓名
    person_tag: [],
    interest: "",
    speciallty: "" //专业，专长
  },
  addressList: [],
  honorList: [],
  schoolList: [],
  workList: [],
  positionList1: [],
  positionList2: [],
  positionList3: [],
  assistantList: []
};

const mutations = {
  clear(state, payload) {
    const key = payload.key;
    if (state[key] instanceof Array){
      state[key] = [];
    } else {
      state[key] = {};
    }
  },
  update(state, payload){
    const key = payload.key;
    if (state[key] instanceof Array){
      state[key] = [
        ...state[key],
        ...payload.value
      ];
    } else {
      state[key] = {
        ...state[key],
        ...payload.value
      };
    }
  }
};

const actions = {
  getCommerceInfo(context){
    return new Promise((reslove, reject)=>{
      $http.post('/api/pc/commerce/getInfo', {
        shid:localStorage.getItem('shid')
      })
      .then(res=>{
        reslove(res);
        if(res.data.code==1){
          context.commit('update', {
            key: 'commerceInfo',
            value: res.data.data
          })
        }
      })
      .catch(err=>{
        reject(err);
      });
    });
  },
  updateOrigin(context) {
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member/myDetail")
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('update', {
            key: 'baseInfo',
            value: res.data.data
          });
        } else if(res.data.code == -404){
          localStorage.setItem('user_token', '');
          window.location.href= "/#/login";
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  updateMoreOrigin(context) {
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member/myInfoMore")
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('update', {
            key: 'baseInfo',
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  updateAddressListOrigin(context) {
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member_address/getlist")
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('clear', {
            key: 'addressList'
          })
          context.commit('update', {
            key: 'addressList',
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  updateHonorListOrigin(context) {
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member_honor/getlist")
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('clear', {
            key: 'honorList'
          })
          context.commit('update', {
            key: 'honorList',
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  updateSchoolListOrigin(context) {
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member_learning_experience/getlist")
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('clear', {
            key: 'schoolList'
          })
          context.commit('update', {
            key: 'schoolList',
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  updateWorkListOrigin(context) {
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member_work_experience/getlist")
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('clear', {
            key: 'workList'
          })
          context.commit('update', {
            key: 'workList',
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  updatePositionListOrigin(context, position_type) {
    if (!position_type) {
      position_type = 1;
    }
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member_position/getlist", {
        position_type
      })
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('clear', {
            key: 'positionList'+position_type
          })
          context.commit('update', {
            key: 'positionList'+position_type,
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  updateAssistantListOrigin(context, position_type) {
    if (!position_type) {
      position_type = 1;
    }
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member_assistant/getlist", {
        position_type
      })
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('clear', {
            key: 'assistantList'
          })
          context.commit('update', {
            key: 'assistantList',
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  getDefaultInfo(context) {
    return new Promise((resolve, reject)=>{
      $http.post("/api/member/member/getMemberConfig")
      .then(res=>{
        resolve(res);
        if(res.data.code===1){
          context.commit('update', {
            key: 'defaultInfo',
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  },
  getArea(context) {
    return new Promise((resolve, reject)=>{
      $http.post("/api/commons/area/getlist")
      .then(res=>{
        if(res.data.code===1){
          let area = [];
          if (res.data.data.province_list) {
            area = formatArea(res.data.data.province_list);
            area = area.map(v=>{
              v.children = formatArea(res.data.data.city_list)
                .filter(k=>parseInt(k.value/1000)==parseInt(v.value/1000));
              v.children = v.children.map(g=>{
                g.children = formatArea(res.data.data.county_list)
                  .filter(k=>parseInt(k.value/100)==parseInt(g.value/100));
                return g;
              });
              return v;
            });
          }
          context.commit('update', {
            key: 'area',
            value: area
          });
          context.commit('update', {
            key: 'areaDefault',
            value: res.data.data
          });
        }
      })
      .catch(err=>{
        reject(err);
      });
    })
  }
};

function formatArea(list){
  let area = [];
  if (list) {
    for (let key in list) {
      area.push({
        value: key,
        label: list[key],
      });
    }
  }
  return area;
}

export default new Vuex.Store({
  state,
  mutations,
  actions
});